import React from 'react';
import { cn } from '@/utils/tailwind';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

type LayoutTableControllerProps = {
  children: React.ReactNode;
  noPX?: boolean;
  className?: string;
};

const LayoutTableController = ({
  children,

  className,
}: LayoutTableControllerProps) => {
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <div
      className={cn('grid h-[80px] gap-[20px]', 'px-[20px]', className)}
      data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
    >
      <div className="scrollbar flex h-[80px] w-full justify-between gap-[20px] overflow-x-auto">
        {children}
      </div>
    </div>
  );
};

export default LayoutTableController;
